import axios from '../../../commons/gdprcontrol-axios'

const state = {
  scheduledEvents: []
}

const getters = {
  getScheduledEvents: state => state.scheduledEvents
}

const actions = {
  fetchScheduledEvents: async ({ commit, rootGetters }) => {
    let URL = '/api/events-schedule/'

    return axios.get(URL)
      .then(response => {
        commit('storeScheduledEvents', response.data.data)
        commit('pagination/setObjectCount', response.data.total, {root: true})
      })
      .catch(error => {
        alert('Failed to get scheduled events')
        throw error
      })
  }
}

const mutations = {
  storeScheduledEvents (state, scheduledEvents) {
    state.scheduledEvents = scheduledEvents
  }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/scheduledEvents/list.js